import { render, staticRenderFns } from "./HomeSwiper.vue?vue&type=template&id=8d3f41fc&scoped=true&"
import script from "./HomeSwiper.vue?vue&type=script&lang=js&"
export * from "./HomeSwiper.vue?vue&type=script&lang=js&"
import style0 from "./HomeSwiper.vue?vue&type=style&index=0&lang=css&"
import style1 from "./HomeSwiper.vue?vue&type=style&index=1&id=8d3f41fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3f41fc",
  null
  
)

export default component.exports